import { namespace } from 'vuex-class'

export default {
    Auth:       namespace('auth'),
    Files:      namespace('files'),
    Cases:      namespace('cases'),
    Creditors:  namespace('creditors'),
    Sources:    namespace('sources'),
    Tags:       namespace('tags'),
}
